<template>
  <main class="page-orderSys-config page-main__wrapper layout">
    <!-- 条件查询部分 -->
    <section class="filter-box">
      <div class="top-btns">
        <el-button @click="$_modify(-1)" class="btn__add">新增外卖平台应用配置</el-button>
      </div>
      <el-form :inline="true" class="filter-form">
        <el-form-item label="外卖平台:">
          <el-select v-model="filter.sysType" filterable style="width: 110px;" placeholder="请选择">
            <el-option label="全部" :value="''"></el-option>
            <el-option
              v-for="item in filter.syses"
              :key="item.companyId"
              :label="item.sysName"
              :value="item.sysType"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="外卖平台应用:">
          <el-input v-model="filter.sysAppName" style="width: 110px;"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button @click="$_search" class="search__btn">查询</el-button>
          <el-button @click="$_reset" class="reset__btn">重置</el-button>
        </el-form-item>
      </el-form>
    </section>

    <main class="table-box">
      <!-- 数据列表 -->
      <el-table
        class="table-list__box"
        ref="tableList"
        :data="dataList"
        :height="tableHeight"
        :rowClassName="$_getRowClass"
        v-loading="isLoading"
        border
        stripe
        tooltip-effect="dark"
      >
        <el-table-column label="操作" width="218" :resizable="false">
          <template slot-scope="scope">
            <el-button class="edit__btn" @click="$_modify(scope.$index, scope.row)">编辑</el-button>
            <el-button class="delete__btn" @click="$_delete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
        <el-table-column
          v-for="column in columns"
          :key="column.key"
          :prop="column.key"
          :label="column.label"
          :width="column.width"
          sortable
          show-overflow-tooltip
          filter-placement="bottom"
          v-if="!column.component"
        ></el-table-column>
        <el-table-column :prop="column.key" :label="column.label" :width="column.width" v-else>
          <template slot-scope="scope">
            <component :is="column.component" :row="scope.row"></component>
          </template>
        </el-table-column>
        <el-table-column></el-table-column>

        <div v-show="!isLoading" class="table-list__empty" slot="empty"></div>
      </el-table>
    </main>
    <!-- 分页 -->
    <div class="pagination__wrapper">
      <cd-pagination
        ref="pager"
        :total="pagination.total"
        :currPage="pagination.pageNow"
        :pageSize="pagination.pageSize"
        @changepage="$_changeCurrent"
        @changesize="$_changeSize"
        :explainShow="true"
        @refresh="$_getConfigs"
      ></cd-pagination>
    </div>

    <modal-modify
      v-if="modal.show && modal.template === 'modify'"
      :title="modal.title"
      :formType="modal.type"
      :modalData="modal.data"
      @callback="$_callback"
      @close="$_close"
    ></modal-modify>
  </main>
</template>

<script>
import resize from "@/mixins/resize";
import ModalModify from "./modal-modify";

const columns = [
  { key: "sysName", label: "外卖平台", width: 120 },
  { key: "sysAppName", label: "外卖平台应用", width: 120 },
  { key: "authUrl", label: "授权URL", width: 160 },
  { key: "memo", label: "备注", width: 160 },
  { key: "creator", label: "创建人", width: 120 },
  { key: "createTime", label: "创建时间", width: 160 },
  { key: "operator", label: "最后编辑人", width: 120 },
  { key: "updateTime", label: "最后编辑时间", width: 160 }
];

export default {
  name: "order-platforms-app-configs",
  mixins: [resize],
  data() {
    return {
      isLoading: false,
      filter: {
        syses: [],
        sysType: "", // 外卖平台编码
        sysAppName: "" // 外卖平台应用
      },
      searchSysData: [],
      tableHeight: null,
      dataList: [],
      columns,
      pagination: {
        pageNow: 1,
        pageSize: 20,
        pages: 0,
        total: 0
      },
      modal: {
        show: false,
        title: "",
        template: "",
        type: "",
        data: {}
      }
    };
  },

  methods: {
    // 搜索
    $_search() {
      this.pagination.pageNow = 1;
      this.$_getConfigs();
    },
    // 重置
    $_reset() {
      this.filter.sysType = "";
      this.filter.sysAppName = "";

      this.pagination.pageNow = 1;
      this.pagination.pageSize = 20;
      this.$_getConfigs();
    },
    // 查询应用配置列表
    $_getConfigs() {
      this.isLoading = true;
      this.$refs.tableList.clearSort();
      const postData = {
        sysType: this.filter.sysType,
        sysAppName: this.filter.sysAppName,
        pageNow: this.pagination.pageNow,
        pageSize: this.pagination.pageSize
      };
      this.$service.post("getTakeawaySysConfigs", postData).then(result => {
        if (result.$.checkResult(result, true)) {
          this.pagination.pages = result.data.pages;
          this.pagination.total = result.data.total;
          this.dataList = result.data.rows.concat([]);
        }
        this.isLoading = false;
      });
    },
    $_getRowClass({ row, rowIndex }) {
      if (row.status === 2) {
        return "is-blocked";
      }
    },
    // 切换每页size
    $_changeSize(page, size) {
      this.pagination.pageSize = size;
      this.pagination.pageNow = 1;
      this.$_getConfigs();
    },
    // 切换当前页
    $_changeCurrent(val) {
      this.pagination.pageNow = val;
      this.$_getConfigs();
    },
    // 更新品牌状态 - 1-启用/2-停用/3-删除
    $_delete(row) {
      const self = this;
      let content = "是否删除当前选项?";
      let sysConfigIds = [row.sysConfigId];
      $MessageBox.confirm({
        content,
        onOk() {
          self.$service
            .post("updateTakeawaySysConfigStatus", {
              sysConfigIds,
              status: 3
            })
            .then(result => {
              if (result.$.checkResult(result, true)) {
                $MessageBox.alert({
                  content: result.msg,
                  onOk() {
                    self.$_getConfigs();
                  }
                });
              }
            });
        }
      });
    },

    $_modify($index, row) {
      this.isLoading = true;
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "新增外卖平台应用配置";
      if ($index !== -1) {
        this.modal.type = "edit";
        this.modal.title = "编辑外卖平台应用配置";
        this.modal.data = JSON.parse(JSON.stringify(row));
      }
      this.modal.template = "modify";
      this.modal.show = true;
      this.isLoading = false;
    },
    // 新增/编辑配置成功回调
    $_callback() {
      this.$_close();
      this.$_getConfigs();
    },
    // 关闭弹窗
    $_close() {
      this.modal.show = false;
      this.modal.template = "";
      this.modal.type = "add";
      this.modal.data = {};
      this.modal.title = "";
    }
  },

  components: {
    ModalModify,
    workModeTmpl: {
      template: `<span>{{row.workMode === 1 ? '标准对接': '非标准对接'}}</span>`,
      props: { row: { type: Object, require: true } }
    }
  },

  async mounted() {
    let height = this.$refs.tableList.$el.parentElement.clientHeight;
    this.tableHeight = `${height}px`;
    // 获取外卖平台列表
    await this.$service
      .post("getOrderCompanyList", {
        pageNow: 1,
        pageSize: 9999,
        sysName: ""
      })
      .then(result => {
        if (result.$.checkResult(result, true)) {
          if (result.data.rows.length > 0) {
            this.filter.syses = result.data.rows.concat([]);
          }
        }
      });
    this.$_getConfigs();
  }
};
</script>

<style lang="scss" scoped>
.layout {
  display: flex;
  flex: auto;
  flex-direction: column;
}
.page-main__wrapper {
  overflow: hidden;
  position: relative;
}

.filter-box {
  color: #68768a;
  background-color: #f5f6f7;
  padding: 20px 20px 10px 20px;

  .top-btns {
    min-height: 40px;
  }

  .filter-form {
    .autocomplete-box {
      display: inline-block;
      position: relative;
      width: 110px;
      .autocomplete-empty {
        padding: 10px;
        margin: 0;
        color: #535353;
        width: 100%;
      }
    }
    .el-form-item {
      margin-top: 12px;
    }
  }
}

.table-box {
  height: 100vh;
  border-top: 1px solid #eee;
  overflow-x: auto;
  position: relative;
}
</style>


